export default __webpack_public_path__ + "static/media/promotion_wechat.8e5a64a1.svg";